import { Box, Container, Link } from '@mui/material';
import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

export class QaHeader extends React.Component {
    public render(): React.ReactNode {
        return (
            <Container maxWidth={false} style={{ background: '#f5f5f5' }}>
                <Box display='flex' sx={{ flexWrap: 'wrap', gap: '1.5rem' }} className='my-1'>
                    <Link to='/qa/impact' component={RouterLink} underline='hover'>
                        Impact Report
                    </Link>
                    <Link to='/qa/f-score' component={RouterLink} underline='hover'>
                        F-Score Report
                    </Link>
                    <Link to='/qa/stat-alert' component={RouterLink} underline='hover'>
                        Seam Stat Alert
                    </Link>
                    <Link to='/qa/channel' component={RouterLink} underline='hover'>
                        Channel Report
                    </Link>
                </Box>
            </Container>
        );
    }
}
